/// <amd-module name="VSS/Legacy/Legacy" />
import React = require("react");

export { ILegacyComponentProperties, ILegacyPlatformService } from "VSS/Legacy/Types";
export { LegacyComponent } from "./Components/Legacy/Legacy";
export { getLWPService, getLWPComponentProps } from "./LegacyPlatformService";
